import * as React from 'react';
import clsx from 'clsx';
import clearChatIcon from '@/assets/images/svg/clear_chat_icon.svg';

interface ClearChatButtonProps {
  onClick: () => void;
  disabled?: boolean | undefined;
}

export const ClearChatButton: React.FC<ClearChatButtonProps> = ({ onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={clsx(
      'flex size-[41px] items-center justify-center',
      'rounded-full',
      'hover:bg-gray-335',
      'hover:rounded-[5px]',
      'hover:size-auto',
      'hover:py-[3px] hover:pl-[7px] hover:pr-[10px]',
      'disabled:cursor-not-allowed disabled:opacity-50'
    )}
    aria-label='Clear Chat'
    title='Clear Chat History'
  >
    <img src={clearChatIcon} alt='Clear Chat' className='size-[22px] object-contain' />
  </button>
);
